import { useContext } from 'react';

import {
  AppBarContext,
  NegModalContext,
  TitlesViewContext,
} from '»utils/contexts';

export const useNegModalContext = () => {
  const context = useContext(NegModalContext);

  if (!context)
    throw new Error(
      'useNegModalContext must be used within a NegModalContextProvider',
    );

  return context;
};

export const useTitlesViewContext = () => {
  const context = useContext(TitlesViewContext);

  if (!context)
    throw new Error(
      'useTitlesViewContext must be used within a TitlesViewContextProvider',
    );

  return context;
};

export const useAppBarContext = () => {
  const context = useContext(AppBarContext);

  if (!context)
    throw new Error(
      'useAppBarContext must be used within a AppBarContextProvider',
    );

  return context;
};
